import { render, staticRenderFns } from "./BannerProductComponent.vue?vue&type=template&id=7ea187fb&scoped=true"
import script from "./BannerProductComponent.vue?vue&type=script&lang=js"
export * from "./BannerProductComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerProductComponent.vue?vue&type=style&index=0&id=7ea187fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea187fb",
  null
  
)

export default component.exports